module.exports = __webpack_public_path__ + "static/media/christian-dior.b5109051.jpg";